// Google Maps (Places autocomplete + Geocoder) is only used by the location
// field during signup/profile edits, so it's loaded on demand there instead
// of as a blocking <script> in index.html on every page (~380 KB that
// delayed the whole app starting on every visit).
const MAPS_SRC = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA1rwNvmOCqoPpdoWthDJw_GHBOgefqQ84&libraries=places';

let mapsPromise = null;

export const loadGoogleMaps = () => {
  if (window.google?.maps?.places) return Promise.resolve(window.google);
  if (mapsPromise) return mapsPromise;
  mapsPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = MAPS_SRC;
    script.async = true;
    script.onload = () => resolve(window.google);
    script.onerror = () => { mapsPromise = null; reject(new Error('Google Maps failed to load')); };
    document.head.appendChild(script);
  });
  return mapsPromise;
};
